import React from "react";
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import MailIcon from '@material-ui/icons/Mail';
import { styled } from "@material-ui/core/styles";

const Phone = styled(PhoneAndroidIcon)({
  color: "rgba(48, 73, 103, 0.8)",
  fontSize: "small",
  marginBottom: "-2px"
});

const Mail = styled(MailIcon)({
  color: "rgba(48, 73, 103, 0.8)",
  fontSize: "small",
  marginBottom: "-2px"
});

function contactsExcelCell(options, column, gridCell) {
  let row = gridCell.data;
  let prefix = column.dataField;

  if (row[prefix]) {
    options.value = row[prefix] || "";
  }
}

function contactsCell(config, columnSpec) {
  let prefix = columnSpec.dataField;
  config.cellRender = ContactsCell;
  config.dataType = "string";
  config.alignment = "left";

  config.calculateCellValue = (row) => {
    if (row[prefix]) {
      return row[prefix] || "";
    } else {
      return null;
    }
  }
}

const ContactsCell = (cellData) => {
  if (cellData.value && cellData.value !== ';') {
    let contactList = cellData.value.split(';');
    return (
      <div>
        {contactList && contactList.length > 0 &&
        contactList.map((c) => (
          c !== '' ? (
          c.includes('@')
          ? <div key={c}><Mail/>&nbsp;{c}</div>
          : <div key={c}><Phone/>&nbsp;{c}</div>) : <></>
          )
        )}
      </div>
    );
  }
  return null;
}

export {contactsCell, contactsExcelCell, ContactsCell}
